import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';
import { useConfig } from '../../../../../context';
import { CdnIcon, CdnIconNames } from '@shared/ui';
import Link from '../../../../../Link/Link';

export interface SearchFormLink {
	title: string;
	url: string;
	openInNewTab?: boolean;
	icon?: string;
	className?: string;
}

const AdditionalLinks: React.FC = () => {
	const {
		SearchForm: { additionalLinks = [] }
	} = useConfig();
	const { AdditionalLinks: css } = useTheme('SearchForm');
	const { t } = useTranslation('SearchForm');

	if (!additionalLinks || additionalLinks.length === 0) {
		return null;
	}

	return (
		<div className={css.container}>
			{(additionalLinks as SearchFormLink[]).map((link, index) => (
				<Link
					key={index}
					action={link.url}
					className={cn(css.link, link.className)}
					target={link.openInNewTab ? '_blank' : undefined}
					{...(link.openInNewTab ? { rel: 'noopener noreferrer' } : {})}
				>
					{link.icon && <CdnIcon icon={link.icon as CdnIconNames} className={css.icon} />}
					<span className={css.title}>{t(link.title)}</span>
				</Link>
			))}
		</div>
	);
};

export default AdditionalLinks;
